module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locale),
      expression: "locale"
    }],
    attrs: {
      "id": "locale-selector"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.locale = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.saveInLocalStorage]
    }
  }, _vm._l((_vm.langSorted), function(lang) {
    return _c('option', {
      domProps: {
        "value": lang.code
      }
    }, [_vm._v("\n      " + _vm._s(lang.name)), (lang.nativeName && lang.nativeName.length > 0) ? _c('span', [_vm._v(" - ")]) : _vm._e(), _vm._v(_vm._s(lang.nativeName) + "\n    ")])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-af372fc4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locale/SetLocale.vue
// module id = 2090
// module chunks = 1